import React, { useState } from "react";
import GenericModal from "./GenericModal";

const initialForm = {
  noticeType: "",
  charge: 0.0,
  suretyCharge: 0.0,
  remarks: "",
  active: true,
  editable: true,
};

const AddNoticeMasterModal = ({
  open,
  onClose,
  onSave,
  data,
}) => {
  const [loading, setLoading] = useState(false);

  const validateForm = (form) => {
    const newErrors = {};
    const numericFields = ["charge", "suretyCharge"];

    if (!form.noticeType?.trim())
      newErrors.noticeType = "Notice Type is required";
    
    numericFields.forEach((field) => {
      if (
        form[field] === "" ||
        isNaN(Number(form[field])) ||
        Number(form[field]) <= 0
      ) {
        newErrors[field] = `${field} must be a number greater than 0`;
      }
    });

    return newErrors;
  };

  const fields = [
    {
      name: "noticeType",
      label: "Notice Type",
      helper: "Type of Notice",
      size: { xs: 12, sm: 12, md:12 }
    },
    {
      name: "charge",
      label: "Charge",
      helper: "Charge amount",
      type: "number",
      adornment: "₹",
      size: { xs: 12, sm: 12, md:12 }
    },
    {
      name: "suretyCharge",
      label: "Surety Charge",
      helper: "Surety charge amount",
      type: "number",
      adornment: "₹",
      size: { xs: 12, sm: 12, md:12 }
    },
    {
      name: "remarks",
      label: "Description / Remarks",
      helper: "Optional",
      multiline: true,
      rows: 2,
      size: { xs: 12, sm: 12, md:12 }
    },
  ];

  return (
    <GenericModal
      open={open}
      onClose={onClose}
      onSave={onSave}
      data={data}
      title="Notice"
      fields={fields}
      initialForm={initialForm}
      validateForm={validateForm}
      saveButtonText="Save Notice"
      updateButtonText="Update Notice"
    />
  );
};

export default AddNoticeMasterModal;
